import { Injectable } from '@angular/core';
import { AppState } from '@get/store/configs/reducers';
import { Actions } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { GeneratedPatrimoineHierarchieTemplateService } from './patrimoine-hierarchie-template-generated.service';

@Injectable({
  providedIn: 'root'
})
export class PatrimoineHierarchieTemplateService extends GeneratedPatrimoineHierarchieTemplateService {
  constructor(store$: Store<AppState>, actions$: Actions) {
    super(store$, actions$);
  }
}
